<template>
  <div id="menber_pay" class="menber_control menber_nav padding-30">
    <TabBar :list="tabList" :active="tabActive" @active="active"/>
    <div class="b_cont">
      <div :class="'order_list order_' + [tabActive === 0 ? tabActive + ' active_bg' : active]">
        <div class="table-responsive">
          <table cellspacing="0" cellpadding="0" class="table table-bordered table-hover table-striped">
            <tbody>
              <tr class="pay_title">
                <td>操作类型</td>
                <td>存入金额</td>
                <td>支出金额</td>
                <td>当前余额</td>
                <td>日期</td>
              </tr>
              <tr v-for="(item, index) in list" :key="item.depositId">
                <td :class="[index%2===0?'danger':'']">{{item.depositType}}</td>
                <td :class="[index%2===0?'danger':'']">￥{{item.credit}}</td>
                <td :class="[index%2===0?'danger':'']">￥{{item.debit}}</td>
                <td :class="[index%2===0?'danger':'']">￥{{item.balance}}</td>
                <td :class="[index%2===0?'danger':'']">{{item.addTime}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <Pagination :page="page" :pageSize="pageSize" :count="count" @change-page="changePage"/>
      </div>
      <div :class="'order_list order_' + [tabActive === 1 ? tabActive + ' active_bg' : active]">
        <ul>
          <li class="m-b-15" :class="{'move_bg':showBg}" @mouseout="showBg = false" @mouseover="showBg = true">
            <div class="order_h padding_t_b_20">
              <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="order_cont">
                  <span class="cont1 col-xs-12 col-sm-6 m-b-5">
                    <strong>充值金额：</strong><i><input name="text1" type="text" v-model="price" placeholder="请填写充值金额"></i>
                  </span>
                  <span class="cont2 col-xs-12 col-sm-6 m-b-5">
                    <strong>支付方式：</strong>
                    <select class="lSelect col-xs-12 col-sm-12 col-md-3" v-model='select' @change='changeSelect'>
                      <option v-for="option in options" v-bind:value="option.value">
                        {{ option.text }}
                      </option>
                    </select>
                  </span>
                </div>
              </div>
            </div>
            <div class="order_b padding_t_b_20">
              <div class="col-xs-12 col-sm-12 col-md-4 m-b-15 order_btn">
                <a href="javascript:;" class="order_recharge" @click="submit">立刻充值</a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import TabBar from '@/components/TabBar'
import Pagination from '@/components/Pagination'
export default {
  components: {
    TabBar,
    Pagination
  },
  data () {
    return {
      // 标签
      tabList: [
        {name: '账户余额记录'},
        {name: '账户充值'}
      ],
      tabActive: 0,
      // 数据
      list: [
        {
          addTime: null,
          updateTime: null,
          depositId: 'ff808181555f4562015599f7d3fa0efd',
          depositType: 'adminRecharge',
          credit: 10000,
          debit: 0,
          balance: 10000,
          payment: null
        },
        {
          addTime: null,
          updateTime: null,
          depositId: 'ff808181575203ad01575fc99cd60292',
          depositType: 'adminRecharge',
          credit: 10000,
          debit: 0,
          balance: 10000,
          payment: null
        }
      ],
      page: 1,
      pageSize: 10,
      count: 11,
      // 边框
      showBg: false,
      // 充值
      price: '',
      select: '',
      options: [
        {value: '', text: '请选择'},
        {value: '微信支付', text: '微信支付'},
        {value: '支付宝', text: '支付宝'}
      ]
    }
  },
  created () {
    this.get()
  },
  methods: {
    active (index) {
      this.tabActive = index
    },
    get () {
      var ctx = this
      window.$.ajax({
        url: '/rest/api/shop/deposit/list',
        data: {
          page: this.page,
          pageSize: this.pageSize
        },
        success (res) {
          if (res.success) {
            ctx.list = res.attributes.data
            ctx.count = res.attributes.count
          } else {
            // window.alert(res.msg)
          }
        }
      })
    },
    changePage (page) {
      this.page = page
      this.get()
    },
    changeSelect (e) {
      this.select = e.target.value
    },
    submit () {
      // if(this.price === '') { return alert("请输入充值金额！") }
      // if (!(/^([1-9][0-9]*)+(.[0-9]{1,2})?$/.test(this.price))) { return alert("请输入正确充值金额！") }
      // if (this.select == '') {return alert('请选择支付方式！')}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Pay.vue